/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 48);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(30)('wks');
var uid = __webpack_require__(20);
var Symbol = __webpack_require__(3).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 1 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = vendor_library;

/***/ }),
/* 3 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 4 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.1' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(13);
var IE8_DOM_DEFINE = __webpack_require__(41);
var toPrimitive = __webpack_require__(26);
var dP = Object.defineProperty;

exports.f = __webpack_require__(7) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(2))(46);

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(14)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 8 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(88);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(3);
var core = __webpack_require__(4);
var ctx = __webpack_require__(40);
var hide = __webpack_require__(11);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && key in exports) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(5);
var createDesc = __webpack_require__(15);
module.exports = __webpack_require__(7) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(45);
var defined = __webpack_require__(24);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(18);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 14 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 15 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 16 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(2))(132);

/***/ }),
/* 18 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(44);
var enumBugKeys = __webpack_require__(31);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 20 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 21 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = parseHiddenFields;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sendAjax__ = __webpack_require__(37);






function parseHiddenFields(el) {
  var fields = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default()(null);
  for (var i in el.attributes) {
    if (el.attributes.hasOwnProperty(i)) {
      var matches = /^data-hidden-([a-z]+.*)/.exec(el.attributes[i].name);
      if (matches) {
        fields[matches[1]] = el.attributes[i].value;
      }
    }
  }

  return fields;
}

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3_vue__["default"].extend({
  data: function data() {
    return {
      ns: 'ajax-form',
      state: {},
      model: {},

      form: {
        hiddenFields: {},
        loading: false,
        submitted: false,
        status: null,
        message: ''
      },

      messages: {
        required: 'Поле не заполнено',
        accept: 'Необходимо принять политику конфиденциальности и пользовательское соглашение',
        email: 'Некорректный email'
      },

      defaultState: {}
    };
  },
  mounted: function mounted() {
    var _this = this;

    if (this.inited && typeof this.inited === 'function') {
      this.inited();
    }

    this.defaultState = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.model);

    this.form.hiddenFields = parseHiddenFields(this.$el);

    setTimeout(function () {
      _this.$el.classList.add('form_state_mounted');
    }, 500);
  },


  methods: {
    addData: function addData(fd) {
      return fd;
    },
    formSubmit: function formSubmit(e) {
      var _this2 = this;

      if (this.state.$invalid) {
        console.warn('Form invalid!');
        return;
      }

      var method = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(e.target).attr('method') || 'POST';
      var action = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(e.target).attr('data-action') || __WEBPACK_IMPORTED_MODULE_2_jquery___default()(e.target).attr('action');

      var formData = new FormData(e.target);
      formData = this.addData(formData);

      this.form.loading = true;
      this.disableSubmit(e, true);

      Object(__WEBPACK_IMPORTED_MODULE_4__sendAjax__["a" /* default */])(action, {
        method: method,
        body: formData
      }).then(function (json) {
        console.log('RESPONSE', json);
        _this2.form.message = json['message'] || '';
        _this2.form.loading = false;
        _this2.showStatus();
        _this2.disableSubmit(e, false);
      }).catch(function (error) {
        console.error(error);
        _this2.form.message = error.toString();
        _this2.form.loading = false;
        _this2.showStatus(false);
        _this2.disableSubmit(e, false);
      });
    },
    resetForm: function resetForm() {
      this.model = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.defaultState);
      this.state._reset();
    },
    showStatus: function showStatus() {
      var status = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      this.form.submitted = true;
      this.form.status = status;
    },
    hideStatus: function hideStatus() {
      this.form.submitted = false;
      this.form.status = null;
      this.resetForm();
    },
    disableSubmit: function disableSubmit(form) {
      var lock = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      __WEBPACK_IMPORTED_MODULE_2_jquery___default()('[type="submit"]', form.target).attr('disabled', lock);
    },
    fid: function fid(name) {
      return this.ns + this._uid + '-' + name;
    }
  }
}));

/***/ }),
/* 23 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 24 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 25 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(18);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(13);
var dPs = __webpack_require__(66);
var enumBugKeys = __webpack_require__(31);
var IE_PROTO = __webpack_require__(29)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(42)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(69).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 28 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(30)('keys');
var uid = __webpack_require__(20);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(3);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};


/***/ }),
/* 31 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(5).f;
var has = __webpack_require__(8);
var TAG = __webpack_require__(0)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(24);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(0);


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(3);
var core = __webpack_require__(4);
var LIBRARY = __webpack_require__(25);
var wksExt = __webpack_require__(34);
var defineProperty = __webpack_require__(5).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 36 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

/**
 * Модуль ajax отправки форм
 *
 * @author      delphinpro <delphinpro@gmail.com>
 * @copyright   copyright © 2017 delphinpro
 * @license     licensed under the MIT license
 */

/* harmony default export */ __webpack_exports__["a"] = (function (target, options) {
  var fetchOptions = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    method: 'POST'
  }, options);

  target = target.replace(/^#/, '');

  return fetch(target, fetchOptions).then(function (response) {
    if (!target) {
      throw new Error('Invalid url');
    }

    if (response.ok) {
      return response.json();
    }

    throw new Error(response.status + ' ' + response.statusText);
  }).then(function (json) {
    if (json['statusOk']) {
      return json;
    }

    throw new Error(json['message'] || 'Server response was not ok');
  });
});

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(63)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(39)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(25);
var $export = __webpack_require__(10);
var redefine = __webpack_require__(43);
var hide = __webpack_require__(11);
var has = __webpack_require__(8);
var Iterators = __webpack_require__(16);
var $iterCreate = __webpack_require__(65);
var setToStringTag = __webpack_require__(32);
var getPrototypeOf = __webpack_require__(70);
var ITERATOR = __webpack_require__(0)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(64);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(7) && !__webpack_require__(14)(function () {
  return Object.defineProperty(__webpack_require__(42)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(18);
var document = __webpack_require__(3).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(11);


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(8);
var toIObject = __webpack_require__(12);
var arrayIndexOf = __webpack_require__(67)(false);
var IE_PROTO = __webpack_require__(29)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(28);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(23);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(44);
var hiddenKeys = __webpack_require__(31).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(49);


/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fancyapps_fancybox__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fancyapps_fancybox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__fancyapps_fancybox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fancyapps_fancybox_dist_jquery_fancybox_css__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fancyapps_fancybox_dist_jquery_fancybox_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__fancyapps_fancybox_dist_jquery_fancybox_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ion_rangeslider__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ion_rangeslider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ion_rangeslider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ion_rangeslider_css_ion_rangeSlider_css__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ion_rangeslider_css_ion_rangeSlider_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_ion_rangeslider_css_ion_rangeSlider_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_slick_carousel__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_slick_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_slick_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_slick_carousel_slick_slick_css__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_slick_carousel_slick_slick_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_slick_carousel_slick_slick_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_form__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_whatwg_fetch__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_whatwg_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_whatwg_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_autoReplace__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Calculator_Calculator_vue__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Calculator_Calculator_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_Calculator_Calculator_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_CallbackForm_vue__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_CallbackForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_CallbackForm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_OrderTariffForm_vue__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_OrderTariffForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_OrderTariffForm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Checkbox_vue__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Checkbox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_Checkbox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_ConsultForm_ConsultForm_vue__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_ConsultForm_ConsultForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_ConsultForm_ConsultForm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_CoolMenu__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_FormStatus_vue__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_FormStatus_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_FormStatus_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_hamburger__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_fixed_bar__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_Modal_vue__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_Modal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_News_News_vue__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_News_News_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_News_News_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_Radio_vue__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_Radio_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_Radio_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_totop__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_whichTransitionEvent__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_YandexMap_vue__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_YandexMap_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_YandexMap_vue__);
/**
 * zel-finance.doseo
 * @since       12.09.2017 14:13
 * @author      delphinpro <delphinpro@gmail.com>
 * @copyright   copyright © 2017 delphinpro
 * @license     licensed under the MIT license
 */




























console.info('Vue version ' + __WEBPACK_IMPORTED_MODULE_7_vue__["default"].version + ', ' + "production" + ' mode');
__WEBPACK_IMPORTED_MODULE_7_vue__["default"].config.devtools = __WEBPACK_IMPORTED_MODULE_7_vue__["default"].config.devtools || location.hostname === 'localhost';
__WEBPACK_IMPORTED_MODULE_7_vue__["default"].config.productionTip = __WEBPACK_IMPORTED_MODULE_7_vue__["default"].config.productionTip && location.hostname !== 'localhost';

__WEBPACK_IMPORTED_MODULE_7_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vue_form___default.a);
__WEBPACK_IMPORTED_MODULE_7_vue__["default"].component('modal', __WEBPACK_IMPORTED_MODULE_20__components_Modal_vue___default.a);
__WEBPACK_IMPORTED_MODULE_7_vue__["default"].component('callback-form', __WEBPACK_IMPORTED_MODULE_12__components_CallbackForm_vue___default.a);
__WEBPACK_IMPORTED_MODULE_7_vue__["default"].component('order-tariff-form', __WEBPACK_IMPORTED_MODULE_13__components_OrderTariffForm_vue___default.a);
__WEBPACK_IMPORTED_MODULE_7_vue__["default"].component('consult-form', __WEBPACK_IMPORTED_MODULE_15__components_ConsultForm_ConsultForm_vue___default.a);
__WEBPACK_IMPORTED_MODULE_7_vue__["default"].component('form-status', __WEBPACK_IMPORTED_MODULE_17__components_FormStatus_vue___default.a);
__WEBPACK_IMPORTED_MODULE_7_vue__["default"].component('yandex-map', __WEBPACK_IMPORTED_MODULE_25__components_YandexMap_vue___default.a);
__WEBPACK_IMPORTED_MODULE_7_vue__["default"].component('news', __WEBPACK_IMPORTED_MODULE_21__components_News_News_vue___default.a);
__WEBPACK_IMPORTED_MODULE_7_vue__["default"].component('radio', __WEBPACK_IMPORTED_MODULE_22__components_Radio_vue___default.a);
__WEBPACK_IMPORTED_MODULE_7_vue__["default"].component('checkbox', __WEBPACK_IMPORTED_MODULE_14__components_Checkbox_vue___default.a);
__WEBPACK_IMPORTED_MODULE_7_vue__["default"].component('calculator', __WEBPACK_IMPORTED_MODULE_11__components_Calculator_Calculator_vue___default.a);

Object(__WEBPACK_IMPORTED_MODULE_10__components_autoReplace__["a" /* default */])(document.body, {
  'icon-yes': '<span class="icon icon_yes"></span>',
  'icon-no': '<span class="icon icon_no"></span>'
});

new __WEBPACK_IMPORTED_MODULE_7_vue__["default"]({
  delimiters: ['((', '))'],

  el: '#root',

  data: {
    modalShow: false,
    modalHeading: '',
    modalComponent: 'callback-form',
    selectedTariff: 1
  },

  mounted: function mounted() {
    console.log('root mounted');
    document.body.classList.toggle('is-locked', this.modalShow);
  },


  watch: {
    modalShow: function modalShow(newState) {
      document.body.classList.toggle('is-locked', newState);
    }
  },

  methods: {
    modal: function modal(heading, component) {
      this.modalHeading = heading;
      this.modalComponent = component;
      this.modalShow = true;
    },
    orderTariff: function orderTariff(tariff) {
      this.selectedTariff = tariff;
      this.modal('Заказать тариф', 'order-tariff-form');
    },
    showCalc: function showCalc(title) {
      this.modal(title || 'Калькулятор', 'calculator');
    }
  }
});

Object(__WEBPACK_IMPORTED_MODULE_18__components_hamburger__["a" /* default */])({
  button: 'js-menu-toggle',
  stateOpenClass: 'hamburger_state_cross',
  stateOpenFlag: 'f-hamburger-open'
});

Object(__WEBPACK_IMPORTED_MODULE_19__components_fixed_bar__["a" /* default */])(document.querySelector('.fixed-bar'), {});

new __WEBPACK_IMPORTED_MODULE_16__components_CoolMenu__["a" /* default */]({
  source: ['.top-menu__items', '.navbar-menu'],
  $button: __WEBPACK_IMPORTED_MODULE_4_jquery___default()('.js-mobile-toggle')
});

__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.navi__item_has_children').prepend('<div class="navi__backdrop"></div>');
__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.navi__item_has_children > .navi__link').on('click', function (e) {
  e.preventDefault();
  __WEBPACK_IMPORTED_MODULE_4_jquery___default()(this).parent().toggleClass('navi__item_state_open');
});
__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.navi__backdrop').on('click', function () {
  __WEBPACK_IMPORTED_MODULE_4_jquery___default()('.navi__item_state_open').removeClass('navi__item_state_open');
});

__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.search__button').on('click', function (e) {
  e.preventDefault();
  __WEBPACK_IMPORTED_MODULE_4_jquery___default()(this).parent().toggleClass('search_state_open');
});
__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.search__backdrop').on('click', function () {
  __WEBPACK_IMPORTED_MODULE_4_jquery___default()('.search_state_open').removeClass('search_state_open');
});

__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.js-experts-carousel').each(function (i, e) {
  var $car = __WEBPACK_IMPORTED_MODULE_4_jquery___default()(e);

  $car.find('.carousel__carousel').slick({
    arrows: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    infinite: false,
    prevArrow: $car.find('.slider-button_prev'),
    nextArrow: $car.find('.slider-button_next'),
    responsive: [{
      breakpoint: 991,
      settings: {
        slidesToShow: 1
      }
    }]
  });
});

__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.js-reviews-carousel').each(function (i, e) {
  var $car = __WEBPACK_IMPORTED_MODULE_4_jquery___default()(e);

  $car.find('.carousel__carousel').slick({
    arrows: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: false,
    prevArrow: $car.find('.slider-button_prev'),
    nextArrow: $car.find('.slider-button_next'),
    responsive: [{
      breakpoint: 1199,
      settings: {
        slidesToShow: 2
      }
    }, {
      breakpoint: 991,
      settings: {
        slidesToShow: 1
      }
    }]
  });
});

__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.top-slider').each(function (i, e) {
  var $slider = __WEBPACK_IMPORTED_MODULE_4_jquery___default()(e);
  var $carousel = __WEBPACK_IMPORTED_MODULE_4_jquery___default()('.top-slider__carousel', $slider);

  $carousel.slick({
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
    prevArrow: $slider.find('.slider-button_prev'),
    nextArrow: $slider.find('.slider-button_next')
  });
});

__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.js-brands-carousel').each(function (i, e) {
  var $slider = __WEBPACK_IMPORTED_MODULE_4_jquery___default()(e);

  __WEBPACK_IMPORTED_MODULE_4_jquery___default()('.brands-carousel__items', $slider).slick({
    arrows: true,
    infinite: true,
    variableWidth: true,
    centerMode: true,
    prevArrow: $slider.find('.slider-button_prev'),
    nextArrow: $slider.find('.slider-button_next')
  });
});

__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.js-fancy').fancybox();

(function () {
  var activeClass = 'is-active';
  var animationClass = 'in';

  __WEBPACK_IMPORTED_MODULE_4_jquery___default()('.tab-container').each(function () {
    var $tabContainer = __WEBPACK_IMPORTED_MODULE_4_jquery___default()(this);
    var $tabList = __WEBPACK_IMPORTED_MODULE_4_jquery___default()('.tab', $tabContainer);
    var $paneList = __WEBPACK_IMPORTED_MODULE_4_jquery___default()('.tab-pane', $tabContainer);

    $tabList.each(function (index, el) {
      var $tab = __WEBPACK_IMPORTED_MODULE_4_jquery___default()(el);

      $tab.on('click', function (event) {
        event.preventDefault();

        if (!$tab.hasClass(activeClass)) {

          $tabList.removeClass(activeClass);
          $tab.addClass(activeClass);

          var $activePane = $paneList.filter('.' + activeClass);
          var $nextPane = $paneList.eq(index);

          $activePane.removeClass(animationClass);
          $activePane.one(__WEBPACK_IMPORTED_MODULE_24__components_whichTransitionEvent__["a" /* default */], function () {
            $activePane.removeClass(activeClass);
            $nextPane.addClass(activeClass);
            setTimeout(function () {
              return $nextPane.addClass(animationClass);
            }, 0);
          });
        }
      });
    });
  });
})();

Object(__WEBPACK_IMPORTED_MODULE_23__components_totop__["a" /* default */])('.totop');

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(2))(128);

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(2))(129);

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(2))(130);

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(2))(131);

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(2))(126);

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(2))(127);

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(2))(136);

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(58))(340);

/***/ }),
/* 58 */
/***/ (function(module, exports) {

module.exports = legacy_library;

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);

/**
 * zel-finance.doseo
 * @since       16.11.2017 22:47
 * @author      delphinpro <delphinpro@gmail.com>
 * @copyright   copyright © 2017 delphinpro
 * @license     licensed under the MIT license
 */

/* harmony default export */ __webpack_exports__["a"] = (function (target, replacement) {

  if (!target instanceof HTMLElement || !target.innerHTML) {
    console.warn('autoReplace: Invalid first argument, HTMLElement expected');
    return;
  }

  if (!(replacement && (typeof replacement === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(replacement)) === 'object')) {
    console.warn('autoReplace: Invalid second argument, Object expected');
    return;
  }

  for (var key in replacement) {
    if (replacement.hasOwnProperty(key)) {
      var re = new RegExp('\\[' + key + '\\]', 'g');
      target.innerHTML = target.innerHTML.replace(re, replacement[key]);
    }
  }
});

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(61);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(75);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(62), __esModule: true };

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(38);
__webpack_require__(71);
module.exports = __webpack_require__(34).f('iterator');


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(23);
var defined = __webpack_require__(24);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 64 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(27);
var descriptor = __webpack_require__(15);
var setToStringTag = __webpack_require__(32);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(11)(IteratorPrototype, __webpack_require__(0)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(5);
var anObject = __webpack_require__(13);
var getKeys = __webpack_require__(19);

module.exports = __webpack_require__(7) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(12);
var toLength = __webpack_require__(46);
var toAbsoluteIndex = __webpack_require__(68);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(23);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(3).document;
module.exports = document && document.documentElement;


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(8);
var toObject = __webpack_require__(33);
var IE_PROTO = __webpack_require__(29)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(72);
var global = __webpack_require__(3);
var hide = __webpack_require__(11);
var Iterators = __webpack_require__(16);
var TO_STRING_TAG = __webpack_require__(0)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(73);
var step = __webpack_require__(74);
var Iterators = __webpack_require__(16);
var toIObject = __webpack_require__(12);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(39)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 73 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 74 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(76), __esModule: true };

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(77);
__webpack_require__(83);
__webpack_require__(84);
__webpack_require__(85);
module.exports = __webpack_require__(4).Symbol;


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(3);
var has = __webpack_require__(8);
var DESCRIPTORS = __webpack_require__(7);
var $export = __webpack_require__(10);
var redefine = __webpack_require__(43);
var META = __webpack_require__(78).KEY;
var $fails = __webpack_require__(14);
var shared = __webpack_require__(30);
var setToStringTag = __webpack_require__(32);
var uid = __webpack_require__(20);
var wks = __webpack_require__(0);
var wksExt = __webpack_require__(34);
var wksDefine = __webpack_require__(35);
var enumKeys = __webpack_require__(79);
var isArray = __webpack_require__(80);
var anObject = __webpack_require__(13);
var toIObject = __webpack_require__(12);
var toPrimitive = __webpack_require__(26);
var createDesc = __webpack_require__(15);
var _create = __webpack_require__(27);
var gOPNExt = __webpack_require__(81);
var $GOPD = __webpack_require__(82);
var $DP = __webpack_require__(5);
var $keys = __webpack_require__(19);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(47).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(21).f = $propertyIsEnumerable;
  __webpack_require__(36).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(25)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    if (it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    replacer = args[1];
    if (typeof replacer == 'function') $replacer = replacer;
    if ($replacer || !isArray(replacer)) replacer = function (key, value) {
      if ($replacer) value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(11)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(20)('meta');
var isObject = __webpack_require__(18);
var has = __webpack_require__(8);
var setDesc = __webpack_require__(5).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(14)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(19);
var gOPS = __webpack_require__(36);
var pIE = __webpack_require__(21);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(28);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(12);
var gOPN = __webpack_require__(47).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(21);
var createDesc = __webpack_require__(15);
var toIObject = __webpack_require__(12);
var toPrimitive = __webpack_require__(26);
var has = __webpack_require__(8);
var IE8_DOM_DEFINE = __webpack_require__(41);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(7) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 83 */
/***/ (function(module, exports) {



/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(35)('asyncIterator');


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(35)('observable');


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(87),
  /* template */
  __webpack_require__(95),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "D:\\dev\\doSEO\\zel-finance.doseo\\source\\js\\components\\Calculator\\Calculator.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Calculator.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-00d56193", Component.options)
  } else {
    hotAPI.reload("data-v-00d56193", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AjaxForm__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sendAjax__ = __webpack_require__(37);





var basePrices = {
  1: { // УСН 6%
    1: 4000,
    31: 6000,
    61: 9000,
    101: 11000,
    151: 14000,
    201: 17000,
    301: 20000,
    451: 23000,
    601: Infinity
  },
  2: { // УСН 15%
    1: 5000,
    31: 9000,
    61: 11000,
    101: 14000,
    151: 17000,
    201: 20000,
    301: 23000,
    451: 28000,
    601: Infinity
  },
  3: { // ОСНО
    1: 7000,
    31: 11000,
    61: 16000,
    101: 19000,
    151: 25000,
    201: 30000,
    301: 35000,
    451: 40000,
    601: Infinity
  }
};

var basePricesZero = {
  1: { // ИП
    0: { // Без сотрудников
      1: { 1: null, 2: null, reports: null }, // УСН 6%
      2: { 1: null, 2: null, reports: null }, // УСН 15%
      3: { 1: 1000, 2: 2000, reports: 2 } // ОСНО
    },
    1: { // С сотрудниками
      1: { 1: 2500, 2: 4000, reports: 5 }, // УСН 6%
      2: { 1: 2500, 2: 4000, reports: 5 }, // УСН 15%
      3: { 1: 3500, 2: 5000, reports: 7 } // ОСНО
    }
  },
  2: { // ООО
    0: { // Без сотрудников
      1: { 1: 1000, 2: 2000, reports: 2 }, // УСН 6%
      2: { 1: 1000, 2: 2000, reports: 2 }, // УСН 15%
      3: { 1: 2000, 2: 2000, reports: 4 } // ОСНО
    },
    1: { // С сотрудниками
      1: { 1: 2500, 2: 4000, reports: 5 }, // УСН 6%
      2: { 1: 2500, 2: 4000, reports: 5 }, // УСН 15%
      3: { 1: 3500, 2: 5000, reports: 7 } // ОСНО
    }
  }
};

function getValueFromRange(key, range) {
  var val = 0;
  for (var i in range) {
    if (!range.hasOwnProperty(i)) continue;
    if (key >= i) {
      val = range[i];
    } else {
      break;
    }
  }
  return val;
}

function fmt(number) {
  if (typeof number !== 'number') {
    return number;
  }

  return number.toFixed(0).replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1 ');
}

function calcInitRangeSlider($el, options) {

  var $slider = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.ion-range-slider', $el);
  var modelName = $slider.data('model');

  $slider.ionRangeSlider(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    hide_min_max: true,
    hide_from_to: true,
    grid: true,
    grid_margin: true

  }, options));

  var instance = $slider.data('ionRangeSlider');
  instance.update({ from: this[modelName] });
  __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.form-control', $el).data('ionRangeSlider', instance);
}

var countDosMax = 600;
var countDocsValues = [0, 30, 60, 100, 150, 200, 300, 450, countDosMax, '\u221E'];

/* harmony default export */ __webpack_exports__["default"] = ({

  mixins: [__WEBPACK_IMPORTED_MODULE_2__AjaxForm__["a" /* default */]],

  props: {
    api: String,
    compact: Boolean
  },

  data: function data() {
    return {
      // Options
      ns: 'calculator',
      isCompact: true,
      viewForm: false,
      // Calc params
      base: 4000,
      tax: 1,
      zero: false,
      legal: 1,
      team: true,
      tariff: 2,
      opt1: false,
      opt2: false,
      opt3: false,
      docs: 1,
      docsValue: 30,
      staff: 0,
      sum: 0,
      sumDisplay: '0',
      reportCount: '',
      contract: false,
      // Form
      hiddenFields: {},
      state: {},
      model: {
        name: '',
        company: '',
        tel: '',
        mail: '',
        message: '',
        accept: true
      },
      messages: {
        required: 'Поле не заполнено',
        accept: 'Необходимо принять политику конфиденциальности и пользовательское соглашение',
        email: 'Некорректный email'
      }
    };
  },
  created: function created() {
    console.log('Calculator created');
    this.isCompact = !!this.compact;
    this.viewForm = !this.isCompact;
  },
  mounted: function mounted() {
    var _this = this;

    this.hiddenFields = Object(__WEBPACK_IMPORTED_MODULE_2__AjaxForm__["b" /* parseHiddenFields */])(this.$el);

    calcInitRangeSlider.bind(this)(__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.calculator-range-docs', this.$el), {
      from_min: 1,
      values: countDocsValues,
      onChange: function onChange(data) {
        _this.docs = data.from;
        _this.docsValue = data.from_value;
        _this.calculate();
      }
    });

    calcInitRangeSlider.bind(this)(__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.calculator-range-staff', this.$el), {
      min: 0,
      max: countDosMax + 1,
      grid_num: (countDosMax + 1) / 100,
      onChange: function onChange(data) {
        _this.staff = data.from;
        _this.calculate();
      }
    });

    this.calculate();
  },


  methods: {
    updateDocs: function updateDocs(e) {
      var val = e.target.value;
      var range = 0;
      countDocsValues.forEach(function (item, index) {
        if (val >= item) range = index + 1;
        if (val > countDosMax) range = countDocsValues.length - 1;
      });

      this.docs = range;
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(e.target).data('ionRangeSlider').update({ from: range });
      this.calculate();
    },
    updateStaff: function updateStaff(e) {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(e.target).data('ionRangeSlider').update({ from: e.target.value });
      this.calculate();
    },
    isDisabledUSN: function isDisabledUSN() {
      return this.zero && this.legal === 1 && !this.team;
    },
    calculate: function calculate() {
      if (this.isDisabledUSN()) {
        this.tax = 3;
      }

      this.zero ? this.calculateZero() : this.calculateDefault();
    },
    calculateDefault: function calculateDefault() {
      /*
       Без галочек
       Базовая ставка + (к-во_сотрудников*500)
         Осуществление производственной или строительной деятельности
       к предыдущему значению + 0,2*(Базовая ставка)
         Раздельный учет при наличии нескольких видов деятельности
       к предыдущему значению + 0,2*(Базовая ставка)
         Осуществление внешнеэкономической деятельности (ВЭД)
       к предыдущему значению + 0,25*(Базовая ставка)
       */
      // this.docsValue = countDocsValues[this.docs];
      this.base = getValueFromRange(this.docsValue, basePrices[this.tax]);
      this.sum = this.base + this.staff * 500;

      var opt1 = this.opt1 ? 0.2 * this.base : 0;
      var opt2 = this.opt2 ? 0.2 * this.base : 0;
      var opt3 = this.opt3 ? 0.25 * this.base : 0;

      this.sum += opt1 + opt2 + opt3;

      this.contract = this.docs > 8 || this.staff > 600;
      this.sumDisplay = this.contract ? 'Цена договорная' : fmt(this.sum);
    },
    calculateZero: function calculateZero() {
      console.log(basePricesZero);
      console.log(this.legal, Number(this.team), this.tax, this.tariff);
      this.sum = basePricesZero[this.legal][Number(this.team)][this.tax][this.tariff];
      this.sumDisplay = fmt(this.sum);
      this.reportCount = basePricesZero[this.legal][Number(this.team)][this.tax]['reports'];
    },
    showForm: function showForm() {
      this.viewForm = true;
    },
    hideForm: function hideForm() {
      this.viewForm = !this.isCompact;
    },
    addData: function addData(fd) {
      fd.append('zero', this.zero);
      fd.append('tax', this.tax);
      fd.append('taxString', ['', 'УСН 6%', 'УСН 15%', 'ОСНО'][this.tax]);

      if (this.zero) {
        fd.append('legal', this.legal);
        fd.append('legalString', ['', 'ИП', 'ООО'][this.legal]);
        fd.append('team', this.team);
        fd.append('tariff', this.tariff);
        fd.append('tariffString', ['', 'Эконом', 'Стандарт'][this.tariff]);
        fd.append('reports', this.reportCount);
      } else {
        fd.append('docs', this.docs);
        fd.append('docsValue', this.docsValue);
        fd.append('staff', this.staff);
        fd.append('opt1', this.opt1);
        fd.append('opt2', this.opt2);
        fd.append('opt3', this.opt3);
        fd.append('contract', this.contract);
      }

      fd.append('sum', this.sum);

      return fd;
    },
    sendForm: function sendForm(e) {
      var _this2 = this;

      console.log('Send form', e, this.state);

      if (this.state.$invalid) {
        console.warn('Form invalid!');
        return;
      }

      var method = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(e.target).attr('method') || 'POST';
      var action = this.api;

      var fd = new FormData(e.target);

      fd.append('tax', this.tax);
      fd.append('taxString', ['', 'УСН 6%', 'УСН 15%', 'ОСНО', 'Нулевая отчетность'][this.tax]);
      fd.append('docs', this.docs);
      fd.append('docsValue', this.docsValue);
      fd.append('staff', this.staff);
      fd.append('opt1', this.opt1);
      fd.append('opt2', this.opt2);
      fd.append('opt3', this.opt3);
      fd.append('sum', this.sum);
      fd.append('contract', this.contract);

      // this.form.loading = true;
      // this.disableSubmit(e, true);

      Object(__WEBPACK_IMPORTED_MODULE_3__sendAjax__["a" /* default */])(action, {
        method: method,
        body: fd
      }).then(function (json) {
        console.log('RESPONSE', json);
        console.log('RESPONSE $_POST', json['$_POST']);
        _this2.form.message = json['message'] || '';
        _this2.form.loading = false;
        _this2.showStatus();
        _this2.disableSubmit(e, false);
      }).catch(function (error) {
        console.error(error);
        _this2.form.message = error.toString();
        _this2.form.loading = false;
        _this2.showStatus(false);
        _this2.disableSubmit(e, false);
      });
    }
  }
});

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(89), __esModule: true };

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(90);
module.exports = __webpack_require__(4).Object.assign;


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(10);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(91) });


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(19);
var gOPS = __webpack_require__(36);
var pIE = __webpack_require__(21);
var toObject = __webpack_require__(33);
var IObject = __webpack_require__(45);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(14)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(93), __esModule: true };

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(94);
var $Object = __webpack_require__(4).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(10);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(27) });


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "calculator",
    class: {
      calculator_view_compact: _vm.compact,
        calculator_state_form: _vm.viewForm
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.viewForm || !_vm.compact),
      expression: "!viewForm || !compact"
    }],
    staticClass: "calculator__main"
  }, [_c('div', {
    staticClass: "calculator__group"
  }, [_c('div', {
    staticClass: "calculator__title"
  }, [_vm._v("Укажите вашу систему налогообложения")]), _vm._v(" "), _c('div', {
    staticClass: "radio-inline-group checkbox-inline-group"
  }, [_c('radio', {
    staticClass: "radio_large",
    attrs: {
      "name": 'calc-radio' + this._uid,
      "value": 1,
      "disabled": _vm.isDisabledUSN()
    },
    on: {
      "change": _vm.calculate
    },
    model: {
      value: (_vm.tax),
      callback: function($$v) {
        _vm.tax = $$v
      },
      expression: "tax"
    }
  }, [_vm._v("УСН 6%")]), _vm._v(" "), _c('radio', {
    staticClass: "radio_large",
    attrs: {
      "name": 'calc-radio' + this._uid,
      "value": 2,
      "disabled": _vm.isDisabledUSN()
    },
    on: {
      "change": _vm.calculate
    },
    model: {
      value: (_vm.tax),
      callback: function($$v) {
        _vm.tax = $$v
      },
      expression: "tax"
    }
  }, [_vm._v("УСН 15%")]), _vm._v(" "), _c('radio', {
    staticClass: "radio_large",
    attrs: {
      "name": 'calc-radio' + this._uid,
      "value": 3
    },
    on: {
      "change": _vm.calculate
    },
    model: {
      value: (_vm.tax),
      callback: function($$v) {
        _vm.tax = $$v
      },
      expression: "tax"
    }
  }, [_vm._v("ОСНО\n        ")]), _vm._v(" "), _c('checkbox', {
    staticClass: "checkbox_large",
    attrs: {
      "name": "zero"
    },
    on: {
      "change": _vm.calculate
    },
    model: {
      value: (_vm.zero),
      callback: function($$v) {
        _vm.zero = $$v
      },
      expression: "zero"
    }
  }, [_vm._v("Нулевая отчетность")])], 1)]), _vm._v(" "), (_vm.zero) ? _c('div', {
    staticClass: "calculator__group"
  }, [_c('div', {
    staticClass: "calculator__title"
  }, [_vm._v("Укажите форму вашего юр. лица:")]), _vm._v(" "), _c('div', {
    staticClass: "radio-inline-group checkbox-inline-group"
  }, [_c('radio', {
    staticClass: "radio_large",
    attrs: {
      "name": 'calc-legal' + this._uid,
      "value": 1
    },
    on: {
      "change": _vm.calculate
    },
    model: {
      value: (_vm.legal),
      callback: function($$v) {
        _vm.legal = $$v
      },
      expression: "legal"
    }
  }, [_vm._v("\n          ИП\n        ")]), _vm._v(" "), _c('radio', {
    staticClass: "radio_large",
    attrs: {
      "name": 'calc-legal' + this._uid,
      "value": 2
    },
    on: {
      "change": _vm.calculate
    },
    model: {
      value: (_vm.legal),
      callback: function($$v) {
        _vm.legal = $$v
      },
      expression: "legal"
    }
  }, [_vm._v("\n          ООО\n        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "calculator__checkbox-option mt-.5"
  }, [_c('checkbox', {
    staticClass: "checkbox_large",
    class: {
      checkbox_align_top: !_vm.compact
    },
    attrs: {
      "name": "team"
    },
    on: {
      "change": _vm.calculate
    },
    model: {
      value: (_vm.team),
      callback: function($$v) {
        _vm.team = $$v
      },
      expression: "team"
    }
  }, [_vm._v("\n          С сотрудниками (кол-во сотрудников более одного)\n        ")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.zero) ? _c('div', {
    staticClass: "calculator__group"
  }, [_c('div', {
    staticClass: "calculator__title"
  }, [_vm._v("Выберите тариф:")]), _vm._v(" "), _c('div', {
    staticClass: "radio-inline-group checkbox-inline-group"
  }, [_c('radio', {
    staticClass: "radio_large",
    attrs: {
      "name": 'calc-tariff' + this._uid,
      "value": 1
    },
    on: {
      "change": _vm.calculate
    },
    model: {
      value: (_vm.tariff),
      callback: function($$v) {
        _vm.tariff = $$v
      },
      expression: "tariff"
    }
  }, [_c('strong', [_vm._v("«Эконом»")])]), _vm._v(" "), _c('radio', {
    staticClass: "radio_large",
    attrs: {
      "name": 'calc-tariff' + this._uid,
      "value": 2
    },
    on: {
      "change": _vm.calculate
    },
    model: {
      value: (_vm.tariff),
      callback: function($$v) {
        _vm.tariff = $$v
      },
      expression: "tariff"
    }
  }, [_c('strong', [_vm._v("«Стандарт»")])])], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.zero),
      expression: "!zero"
    }],
    staticClass: "calculator__group"
  }, [_c('div', {
    staticClass: "calculator__title"
  }, [_vm._v("Количество документов в месяц")]), _vm._v(" "), _c('div', {
    staticClass: "calculator__range calculator-range calculator-range-docs"
  }, [_c('div', {
    staticClass: "calculator-range__input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.docsValue),
      expression: "docsValue",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "pattern": "[0-9]{0,4}",
      "min": "1",
      "max": "9999",
      "placeholder": ""
    },
    domProps: {
      "value": _vm.docsValue,
      "value": (_vm.docsValue)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.docsValue = _vm._n($event.target.value)
      }, _vm.updateDocs],
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.zero),
      expression: "!zero"
    }],
    staticClass: "calculator__group"
  }, [_c('div', {
    staticClass: "calculator__title"
  }, [_vm._v("Количество сотрудников компании")]), _vm._v(" "), _c('div', {
    staticClass: "calculator__range calculator-range calculator-range-staff"
  }, [_c('div', {
    staticClass: "calculator-range__input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.staff),
      expression: "staff"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "pattern": "[0-9]{0,4}",
      "min": "0",
      "max": "9999",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.staff)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.staff = $event.target.value
      }, _vm.updateStaff]
    }
  })]), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.zero),
      expression: "!zero"
    }],
    staticClass: "calculator__group"
  }, [_c('div', {
    staticClass: "calculator__title"
  }, [_vm._v("Дополнительно")]), _vm._v(" "), _c('div', {
    class: {
      'row': !_vm.compact
    }
  }, [_c('div', {
    staticClass: "calculator__checkbox-option",
    class: {
      'col-xl-4': !_vm.compact
    }
  }, [_c('checkbox', {
    staticClass: "checkbox_large",
    class: {
      checkbox_align_top: !_vm.compact
    },
    attrs: {
      "name": "opt1"
    },
    on: {
      "change": _vm.calculate
    },
    model: {
      value: (_vm.opt1),
      callback: function($$v) {
        _vm.opt1 = $$v
      },
      expression: "opt1"
    }
  }, [_vm._v("\n            Осуществление производственной или строительной деятельности\n          ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "calculator__checkbox-option",
    class: {
      'col-xl-4': !_vm.compact
    }
  }, [_c('checkbox', {
    staticClass: "checkbox_large",
    class: {
      checkbox_align_top: !_vm.compact
    },
    attrs: {
      "name": "opt2"
    },
    on: {
      "change": _vm.calculate
    },
    model: {
      value: (_vm.opt2),
      callback: function($$v) {
        _vm.opt2 = $$v
      },
      expression: "opt2"
    }
  }, [_vm._v("\n            Раздельный учёт при наличии нескольких видов деятельности\n          ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "calculator__checkbox-option",
    class: {
      'col-xl-4': !_vm.compact
    }
  }, [_c('checkbox', {
    staticClass: "checkbox_large",
    class: {
      checkbox_align_top: !_vm.compact
    },
    attrs: {
      "name": "opt3"
    },
    on: {
      "change": _vm.calculate
    },
    model: {
      value: (_vm.opt3),
      callback: function($$v) {
        _vm.opt3 = $$v
      },
      expression: "opt3"
    }
  }, [_vm._v("\n            Осуществление внешнеэкономической деятельности (ВЭД)\n          ")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "calculator__footer"
  }, [_c('div', {
    staticClass: "row row-flex row-flex_center"
  }, [_c('div', {
    class: {
      'col-md-7': _vm.compact,
      'col-md-12': !_vm.compact
    }
  }, [_c('div', {
    staticClass: "calculator__text1"
  }, [_vm._v("Примерная стоимость услуг бухгалтера")]), _vm._v(" "), (_vm.zero && _vm.reportCount) ? _c('div', {
    staticClass: "calculator__text1"
  }, [_vm._v("от " + _vm._s(_vm.reportCount) + " отчётов в квартал")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "calculator__cost"
  }, [(_vm.zero) ? _c('i', [_vm._v("От ")]) : _vm._e(), _c('span', [_vm._v(_vm._s(_vm.sumDisplay))]), _vm._v(" "), (!_vm.contract) ? _c('i', [_vm._v("руб./месяц")]) : _vm._e()])]), _vm._v(" "), (_vm.compact) ? _c('div', {
    staticClass: "col-md-5 text-md-right"
  }, [(!_vm.viewForm) ? _c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.showForm
    }
  }, [_vm._v("Заказать услуги")]) : _vm._e(), _vm._v(" "), (_vm.viewForm) ? _c('a', {
    staticClass: "calculator__back",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.hideForm($event)
      }
    }
  }, [_vm._v("Вернуться к калькулятору")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (!_vm.viewForm || !_vm.compact) ? _c('div', {
    staticClass: "calculator__note"
  }, [_vm._v("\n      Стоимость услуг ориентировочная. Каждая организация имеет свою специфику, поэтому, для точного определения\n      стоимости услуг, необходим предварительный анализ Ваших документов\n    ")]) : _vm._e()]), _vm._v(" "), (_vm.viewForm) ? _c('div', {
    staticClass: "calculator__form form form_loading_main-color",
    class: {
      form_state_status: _vm.form.status !== null,
        form_state_loading: _vm.form.loading
    }
  }, [(_vm.form.loading) ? _c('div', {
    staticClass: "form__loading form-loading form-loading_main-color"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form__form"
  }, [_c('div', {
    staticClass: "calculator__group"
  }, [_c('div', {
    staticClass: "calculator__heading h2"
  }, [_vm._v("Заявка на услугу")]), _vm._v(" "), _c('div', {
    staticClass: "calculator__title",
    class: {
      'text-center': !_vm.compact
    }
  }, [_vm._v("\n          Заполните небольшую форму и наш менеджер свяжется с вами в ближайшее время\n        ")]), _vm._v(" "), (!_vm.compact) ? _c('p', {
    staticClass: "calculator__text"
  }, [_vm._v("\n          Вы можете заполнить форму без предварительного расчета и мы сами рассчитаем стоимость ведения вашей бухгалтерии\n        ")]) : _vm._e(), _vm._v(" "), _c('vue-form', {
    attrs: {
      "method": "post",
      "action": "#",
      "data-action": _vm.api,
      "state": _vm.state
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.formSubmit($event)
      }
    }
  }, [_vm._l((_vm.hiddenFields), function(value, name) {
    return _c('input', {
      attrs: {
        "name": name,
        "type": "hidden"
      },
      domProps: {
        "value": value
      }
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "row row-flex"
  }, [_c('div', {
    class: {
      'col-md-6': _vm.compact, 'col-md-4': !_vm.compact
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": _vm.fid('name')
    }
  }, [_vm._v("\n                  Ваше имя "), _c('i', {
    staticClass: "req req_yellow",
    class: {
      req_white: !_vm.compact
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('validate', {
    staticClass: "inputbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.name),
      expression: "model.name"
    }],
    staticClass: "inputbox__input form-control",
    attrs: {
      "id": _vm.fid('name'),
      "required": "",
      "name": "name",
      "type": "text"
    },
    domProps: {
      "value": (_vm.model.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.state.$submitted && _vm.state.name.$invalid) ? _c('field-messages', {
    staticClass: "inputbox__state form-state",
    attrs: {
      "name": "name"
    }
  }, [_c('div', {
    staticClass: "form-state__message",
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v(_vm._s(_vm.messages.required))])]) : _vm._e()], 1)], 1)]), _vm._v(" "), (_vm.compact) ? _c('div', {
    class: {
      'col-md-6': _vm.compact, 'col-md-4': !_vm.compact
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": _vm.fid('company')
    }
  }, [_vm._v("Название компании")]), _vm._v(" "), _c('validate', {
    staticClass: "inputbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.company),
      expression: "model.company"
    }],
    staticClass: "inputbox__input form-control",
    attrs: {
      "id": _vm.fid('company'),
      "name": "company",
      "type": "text"
    },
    domProps: {
      "value": (_vm.model.company)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "company", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.state.$submitted && _vm.state.company.$invalid) ? _c('field-messages', {
    staticClass: "inputbox__state form-state",
    attrs: {
      "name": "company"
    }
  }, [_c('div', {
    staticClass: "form-state__message",
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v(_vm._s(_vm.messages.required))])]) : _vm._e()], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    class: {
      'col-md-6': _vm.compact, 'col-md-4': !_vm.compact
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": _vm.fid('tel')
    }
  }, [_vm._v("\n                  Телефон "), _c('i', {
    staticClass: "req req_yellow",
    class: {
      req_white: !_vm.compact
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('validate', {
    staticClass: "inputbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.tel),
      expression: "model.tel"
    }],
    staticClass: "inputbox__input-field form-control",
    attrs: {
      "id": _vm.fid('tel'),
      "required": "",
      "name": "tel",
      "type": "tel"
    },
    domProps: {
      "value": (_vm.model.tel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "tel", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.state.$submitted && _vm.state.tel.$invalid) ? _c('field-messages', {
    staticClass: "inputbox__state form-state",
    attrs: {
      "name": "tel"
    }
  }, [_c('div', {
    staticClass: "form-state__message",
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v(_vm._s(_vm.messages.required))])]) : _vm._e()], 1)], 1)]), _vm._v(" "), _c('div', {
    class: {
      'col-md-6': _vm.compact, 'col-md-4': !_vm.compact
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": _vm.fid('mail')
    }
  }, [_vm._v("\n                  Email "), (!_vm.compact) ? _c('i', {
    staticClass: "req req_yellow",
    class: {
      req_white: !_vm.compact
    }
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('validate', {
    staticClass: "inputbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.mail),
      expression: "model.mail"
    }],
    staticClass: "inputbox__input-field form-control",
    attrs: {
      "id": _vm.fid('mail'),
      "required": !_vm.compact,
      "name": "mail",
      "type": "email"
    },
    domProps: {
      "value": (_vm.model.mail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "mail", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.state.$submitted && _vm.state.mail.$invalid) ? _c('field-messages', {
    staticClass: "inputbox__state form-state",
    attrs: {
      "name": "mail"
    }
  }, [_c('div', {
    staticClass: "form-state__message",
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v(_vm._s(_vm.messages.required))]), _vm._v(" "), _c('div', {
    staticClass: "form-state__message",
    attrs: {
      "slot": "email"
    },
    slot: "email"
  }, [_vm._v(_vm._s(_vm.messages.email))])]) : _vm._e()], 1)], 1)]), _vm._v(" "), _c('div', {
    class: {
      'col-md-6': _vm.compact, 'col-md-5 col-lg-8': !_vm.compact
    }
  }, [_c('div', {
    staticClass: "from-group"
  }, [_c('label', {
    attrs: {
      "for": _vm.fid('message')
    }
  }, [_vm._v("Комментарий")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.message),
      expression: "model.message"
    }],
    staticClass: "form-control",
    attrs: {
      "id": _vm.fid('message'),
      "name": "message",
      "cols": "30",
      "rows": "10"
    },
    domProps: {
      "value": (_vm.model.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "message", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "calculator__form-item-last",
    class: {
      'col-md-6': _vm.compact, 'col-md-7 col-lg-4': !_vm.compact
    }
  }, [_c('div', {
    staticClass: "note"
  }, [_c('span', {
    staticClass: "note__star",
    class: {
      note__star_white: !_vm.compact
    }
  }, [_vm._v("*")]), _vm._v("\n                — обязательно для заполнения\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('validate', [_c('div', {
    staticClass: "checkbox"
  }, [(_vm.state.$submitted && _vm.state.accept.$invalid) ? _c('field-messages', {
    staticClass: "checkbox__state form-state",
    attrs: {
      "name": "accept"
    }
  }, [_c('div', {
    staticClass: "form-state__message",
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v(_vm._s(_vm.messages.accept))])]) : _vm._e(), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.accept),
      expression: "model.accept"
    }],
    attrs: {
      "name": "accept",
      "type": "checkbox",
      "checked": "",
      "required": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.model.accept) ? _vm._i(_vm.model.accept, null) > -1 : (_vm.model.accept)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.model.accept,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.accept = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.model.accept = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.model, "accept", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('i'), _vm._v(" "), _c('span', [_vm._v("Принимаю "), _c('a', {
    staticClass: "link-dotted",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("политику конфиденциальности")]), _vm._v(" и\n                      "), _c('a', {
    staticClass: "link-dotted",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("пользовательское соглашение")])])])], 1)])], 1), _vm._v(" "), (_vm.compact) ? _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn calculator__",
    attrs: {
      "type": "submit",
      "disabled": !(_vm.model.accept)
    }
  }, [_vm._v("\n                  Заказать услуги\n                ")])]) : _vm._e()]), _vm._v(" "), (!_vm.compact) ? _c('div', {
    class: {
      'col-md-6 col-md-offset-3 col-lg-4 col-lg-offset-4': !_vm.compact
    }
  }, [_c('button', {
    staticClass: "btn btn_block calculator__",
    attrs: {
      "type": "submit",
      "disabled": !(_vm.model.accept)
    }
  }, [_vm._v("\n                Заказать услуги\n              ")])]) : _vm._e()])], 2)], 1)]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "status"
    }
  }, [(_vm.form.status !== null) ? _c('form-status', {
    staticClass: "form__status",
    attrs: {
      "theme": !_vm.compact ? 'without-color' : '',
      "status": _vm.form.status,
      "message": _vm.form.message
    },
    on: {
      "close": function($event) {
        _vm.hideStatus();
        _vm.hideForm()
      }
    }
  }) : _vm._e()], 1)], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "calculator-range__slider"
  }, [_c('input', {
    staticClass: "ion-range-slider",
    attrs: {
      "type": "hidden",
      "data-model": "docs"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "calculator-range__slider"
  }, [_c('input', {
    staticClass: "ion-range-slider",
    attrs: {
      "type": "hidden",
      "data-model": "staff"
    }
  })])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-00d56193", module.exports)
  }
}

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(97),
  /* template */
  __webpack_require__(98),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "D:\\dev\\doSEO\\zel-finance.doseo\\source\\js\\components\\CallbackForm.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] CallbackForm.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-286cf515", Component.options)
  } else {
    hotAPI.reload("data-v-286cf515", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AjaxForm__ = __webpack_require__(22);



/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__AjaxForm__["a" /* default */]],
  props: {
    api: String,
    method: String
  },
  data: function data() {
    return {
      model: {
        name: '',
        tel: '',
        accept: true
      }
    };
  }
});

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form",
    class: {
      form_state_status: _vm.form.status !== null
    }
  }, [(_vm.form.loading) ? _c('div', {
    staticClass: "form__loading form-loading"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form__form"
  }, [_c('p', [_vm._v("Заполните небольшую форму и наш менеджер свяжется с вами в ближайшее время")]), _vm._v(" "), _c('vue-form', {
    attrs: {
      "action": "#",
      "method": _vm.method,
      "data-action": _vm.api,
      "state": _vm.state
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.formSubmit($event)
      }
    }
  }, [_vm._l((_vm.form.hiddenFields), function(value, name) {
    return _c('input', {
      attrs: {
        "name": name,
        "type": "hidden"
      },
      domProps: {
        "value": value
      }
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('validate', {
    staticClass: "inputbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.name),
      expression: "model.name"
    }],
    staticClass: "inputbox__input form-control",
    attrs: {
      "required": "",
      "name": "name",
      "type": "text",
      "placeholder": "Ваше имя *"
    },
    domProps: {
      "value": (_vm.model.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.state.$submitted && _vm.state.name.$invalid) ? _c('field-messages', {
    staticClass: "inputbox__state form-state",
    attrs: {
      "name": "name"
    }
  }, [_c('div', {
    staticClass: "form-state__message",
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v(_vm._s(_vm.messages.required))])]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('validate', {
    staticClass: "inputbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.tel),
      expression: "model.tel"
    }],
    staticClass: "inputbox__input-field form-control",
    attrs: {
      "required": "",
      "name": "tel",
      "type": "tel",
      "placeholder": "Телефон *"
    },
    domProps: {
      "value": (_vm.model.tel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "tel", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.state.$submitted && _vm.state.tel.$invalid) ? _c('field-messages', {
    staticClass: "inputbox__state form-state",
    attrs: {
      "name": "tel"
    }
  }, [_c('div', {
    staticClass: "form-state__message",
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v(_vm._s(_vm.messages.required))])]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('validate', [_c('div', {
    staticClass: "checkbox"
  }, [(_vm.state.$submitted && _vm.state.accept.$invalid) ? _c('field-messages', {
    staticClass: "checkbox__state form-state",
    attrs: {
      "name": "accept"
    }
  }, [_c('div', {
    staticClass: "form-state__message",
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v(_vm._s(_vm.messages.accept))])]) : _vm._e(), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.accept),
      expression: "model.accept"
    }],
    attrs: {
      "name": "accept",
      "type": "checkbox",
      "checked": "",
      "required": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.model.accept) ? _vm._i(_vm.model.accept, null) > -1 : (_vm.model.accept)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.model.accept,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.accept = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.model.accept = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.model, "accept", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('i'), _vm._v(" "), _c('span', [_vm._v("\n              Принимаю "), _c('a', {
    staticClass: "link-dotted",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("политику конфиденциальности")]), _vm._v(" и\n              "), _c('a', {
    staticClass: "link-dotted",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("пользовательское соглашение")])])])], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn_block btn_small",
    attrs: {
      "type": "submit",
      "disabled": !(_vm.model.accept)
    }
  }, [_vm._v("\n          Перезвоните мне\n        ")])])], 2)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "status"
    }
  }, [(_vm.form.status !== null) ? _c('form-status', {
    staticClass: "form__status",
    attrs: {
      "status": _vm.form.status,
      "message": _vm.form.message
    },
    on: {
      "close": function($event) {
        _vm.hideStatus()
      }
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-286cf515", module.exports)
  }
}

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(100),
  /* template */
  __webpack_require__(101),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "D:\\dev\\doSEO\\zel-finance.doseo\\source\\js\\components\\OrderTariffForm.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] OrderTariffForm.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-446c10ba", Component.options)
  } else {
    hotAPI.reload("data-v-446c10ba", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AjaxForm__ = __webpack_require__(22);



/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__AjaxForm__["a" /* default */]],

  props: {
    api: String,
    method: String,
    tariff: [Number]
  },

  data: function data() {
    return {
      model: {
        name: '',
        tel: '',
        message: '',
        accept: true
      }
    };
  },


  methods: {
    getTariffName: function getTariffName(tariff) {
      return ['Старт', 'Оптимальный', 'Макси'][tariff - 1];
    }
  }
});

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form",
    class: {
      form_state_status: _vm.form.status !== null,
        form_state_loading: _vm.form.loading,
        'form-consult_with-comment': _vm.comment
    }
  }, [(_vm.form.loading) ? _c('div', {
    staticClass: "form__loading form-loading"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form__form"
  }, [_c('vue-form', {
    attrs: {
      "action": "#",
      "data-action": _vm.api,
      "method": _vm.method,
      "state": _vm.state
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.formSubmit($event)
      }
    }
  }, [_vm._l((_vm.form.hiddenFields), function(value, name) {
    return _c('input', {
      attrs: {
        "name": name,
        "type": "hidden"
      },
      domProps: {
        "value": value
      }
    })
  }), _vm._v(" "), _c('input', {
    attrs: {
      "name": "tariff",
      "type": "hidden"
    },
    domProps: {
      "value": _vm.tariff
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "name": "tariffName",
      "type": "hidden"
    },
    domProps: {
      "value": _vm.getTariffName(_vm.tariff)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-groups"
  }, [_c('div', {
    staticClass: "form-group text-center"
  }, [_c('p', {
    staticClass: "lead"
  }, [_vm._v("«" + _vm._s(_vm.getTariffName(_vm.tariff)) + "»")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('validate', {
    staticClass: "inputbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.name),
      expression: "model.name"
    }],
    staticClass: "inputbox__input form-control",
    attrs: {
      "required": "",
      "name": "name",
      "type": "text",
      "placeholder": "Ваше имя *"
    },
    domProps: {
      "value": (_vm.model.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.state.$submitted && _vm.state.name.$invalid) ? _c('field-messages', {
    staticClass: "inputbox__state form-state",
    attrs: {
      "name": "name"
    }
  }, [_c('div', {
    staticClass: "form-state__message",
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v(_vm._s(_vm.messages.required))])]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('validate', {
    staticClass: "inputbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.tel),
      expression: "model.tel"
    }],
    staticClass: "inputbox__input-field form-control",
    attrs: {
      "placeholder": "Телефон *",
      "required": "",
      "name": "tel",
      "type": "tel"
    },
    domProps: {
      "value": (_vm.model.tel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "tel", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.state.$submitted && _vm.state.tel.$invalid) ? _c('field-messages', {
    staticClass: "inputbox__state form-state",
    attrs: {
      "name": "tel"
    }
  }, [_c('div', {
    staticClass: "form-state__message",
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v(_vm._s(_vm.messages.required))])]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('validate', {
    staticClass: "inputbox"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.message),
      expression: "model.message"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "message",
      "placeholder": "Комментарий"
    },
    domProps: {
      "value": (_vm.model.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "message", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.state.$submitted && _vm.state.message.$invalid) ? _c('field-messages', {
    staticClass: "inputbox__state form-state",
    attrs: {
      "name": "message"
    }
  }, [_c('div', {
    staticClass: "form-state__message",
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v(_vm._s(_vm.messages.required))])]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('validate', [_c('div', {
    staticClass: "checkbox"
  }, [(_vm.state.$submitted && _vm.state.accept.$invalid) ? _c('field-messages', {
    staticClass: "checkbox__state form-state",
    attrs: {
      "name": "accept"
    }
  }, [_c('div', {
    staticClass: "form-state__message",
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v(_vm._s(_vm.messages.accept))])]) : _vm._e(), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.accept),
      expression: "model.accept"
    }],
    attrs: {
      "name": "accept",
      "type": "checkbox",
      "checked": "",
      "required": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.model.accept) ? _vm._i(_vm.model.accept, null) > -1 : (_vm.model.accept)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.model.accept,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.accept = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.model.accept = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.model, "accept", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('i'), _vm._v(" "), _c('span', [_vm._v("\n              Принимаю "), _c('a', {
    staticClass: "link-dotted",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("политику конфиденциальности")]), _vm._v(" и\n              "), _c('a', {
    staticClass: "link-dotted",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("пользовательское соглашение")])])])], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn",
    attrs: {
      "type": "submit",
      "disabled": !(_vm.model.accept)
    }
  }, [_vm._v("Заказать")])])])])], 2)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "status"
    }
  }, [(_vm.form.status !== null) ? _c('form-status', {
    staticClass: "form__status",
    attrs: {
      "status": _vm.form.status,
      "message": _vm.form.message
    },
    on: {
      "close": function($event) {
        _vm.hideStatus()
      }
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-446c10ba", module.exports)
  }
}

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(103),
  /* template */
  __webpack_require__(104),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "D:\\dev\\doSEO\\zel-finance.doseo\\source\\js\\components\\Checkbox.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Checkbox.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-b20971a2", Component.options)
  } else {
    hotAPI.reload("data-v-b20971a2", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(17);



/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  props: ['name', 'checked'],
  model: {
    prop: 'checked',
    event: 'change'
  },
  data: function data() {
    return {
      val: this.checked
    };
  },

  methods: {
    onChange: function onChange() {
      this.$emit('change', this.val);
    }
  }
}));

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.val),
      expression: "val"
    }],
    attrs: {
      "type": "checkbox",
      "name": _vm.name
    },
    domProps: {
      "checked": _vm.checked,
      "checked": Array.isArray(_vm.val) ? _vm._i(_vm.val, null) > -1 : (_vm.val)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.val,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.val = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.val = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.val = $$c
        }
      }, _vm.onChange]
    }
  }), _vm._v(" "), _c('i'), _c('span', [_vm._t("default")], 2)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-b20971a2", module.exports)
  }
}

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(106),
  /* template */
  __webpack_require__(107),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "D:\\dev\\doSEO\\zel-finance.doseo\\source\\js\\components\\ConsultForm\\ConsultForm.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ConsultForm.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-785e6735", Component.options)
  } else {
    hotAPI.reload("data-v-785e6735", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AjaxForm__ = __webpack_require__(22);
/**
 * Consult form
 */


/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__AjaxForm__["a" /* default */]],

  props: {
    api: String,
    method: String,
    comment: Boolean
  },

  data: function data() {
    return {
      model: {
        name: '',
        tel: '',
        message: '',
        accept: true
      }
    };
  }
});

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form",
    class: {
      form_state_status: _vm.form.status !== null,
        form_state_loading: _vm.form.loading,
        'form-consult_with-comment': _vm.comment
    }
  }, [(_vm.form.loading) ? _c('div', {
    staticClass: "form__loading form-loading"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form__form"
  }, [_c('vue-form', {
    attrs: {
      "action": "#",
      "data-action": _vm.api,
      "method": _vm.method,
      "state": _vm.state
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.formSubmit($event)
      }
    }
  }, [_vm._l((_vm.form.hiddenFields), function(value, name) {
    return _c('input', {
      attrs: {
        "name": name,
        "type": "hidden"
      },
      domProps: {
        "value": value
      }
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "h1"
  }, [_vm._v("Остались вопросы?")]), _vm._v(" "), _c('div', {
    staticClass: "subheading"
  }, [_vm._v("Получите консультацию главного бухгалера")]), _vm._v(" "), _c('div', {
    class: {
      row: _vm.comment
    }
  }, [_c('div', {
    class: {
      'col-lg-7 col-xl-8': _vm.comment
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-consult__col col-md-6",
    class: {
      'col-lg-5 col-lg-offset-1 col-xl-4 col-xl-offset-2': !_vm.comment
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('validate', {
    staticClass: "inputbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.name),
      expression: "model.name"
    }],
    staticClass: "inputbox__input form-control",
    attrs: {
      "placeholder": "Ваше имя *",
      "required": "",
      "name": "name",
      "type": "text"
    },
    domProps: {
      "value": (_vm.model.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.state.$submitted && _vm.state.name.$invalid) ? _c('field-messages', {
    staticClass: "inputbox__state form-state",
    attrs: {
      "name": "name"
    }
  }, [_c('div', {
    staticClass: "form-state__message",
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v(_vm._s(_vm.messages.required))])]) : _vm._e()], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-consult__col col-md-6",
    class: {
      'col-lg-5 col-xl-4': !_vm.comment
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('validate', {
    staticClass: "inputbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.tel),
      expression: "model.tel"
    }],
    staticClass: "inputbox__input-field form-control",
    attrs: {
      "placeholder": "Телефон *",
      "required": "",
      "name": "tel",
      "type": "tel"
    },
    domProps: {
      "value": (_vm.model.tel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "tel", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.state.$submitted && _vm.state.tel.$invalid) ? _c('field-messages', {
    staticClass: "inputbox__state form-state",
    attrs: {
      "name": "tel"
    }
  }, [_c('div', {
    staticClass: "form-state__message",
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v(_vm._s(_vm.messages.required))])]) : _vm._e()], 1)], 1)])]), _vm._v(" "), (_vm.comment) ? _c('div', {
    staticClass: "mt-1"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.message),
      expression: "model.message"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "message",
      "placeholder": "Комментарий"
    },
    domProps: {
      "value": (_vm.model.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "message", $event.target.value)
      }
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: {
      'mt-1 mt-lg-0 col-lg-5 col-xl-4': _vm.comment
    }
  }, [_c('div', {
    staticClass: "text-center",
    class: {
      'form-consult__note': !_vm.comment, 'text-lg-left': _vm.comment
    }
  }, [_c('div', {
    staticClass: "note"
  }, [_c('span', {
    staticClass: "note__star"
  }, [_vm._v("*")]), _vm._v(" — обязательно для заполнения")])]), _vm._v(" "), _c('div', {
    staticClass: "form-consult__accept text-center",
    class: {
      'mt-.5 text-lg-left': _vm.comment
    }
  }, [_c('validate', {
    staticClass: "checkbox"
  }, [(_vm.state.$submitted && _vm.state.accept.$invalid) ? _c('field-messages', {
    staticClass: "checkbox__state form-state",
    attrs: {
      "name": "accept"
    }
  }, [_c('div', {
    staticClass: "form-state__message",
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v(_vm._s(_vm.messages.accept))])]) : _vm._e(), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.accept),
      expression: "model.accept"
    }],
    attrs: {
      "name": "accept",
      "type": "checkbox",
      "checked": "",
      "required": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.model.accept) ? _vm._i(_vm.model.accept, null) > -1 : (_vm.model.accept)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.model.accept,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.accept = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.model.accept = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.model, "accept", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('i'), _vm._v(" "), _c('span', [_vm._v("Принимаю "), _c('a', {
    staticClass: "link-yellow link-dotted",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("политику конфиденциальности")]), _vm._v(" и\n                    "), _c('br', {
    staticClass: "hidden-md"
  }), _vm._v(" "), _c('a', {
    staticClass: "link-yellow link-dotted",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("пользовательское соглашение")])])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-consult__footer text-center",
    class: {
      'text-lg-left': _vm.comment
    }
  }, [_c('button', {
    staticClass: "btn btn_inverse",
    attrs: {
      "type": "submit",
      "disabled": !(_vm.model.accept)
    }
  }, [_vm._v("Получить консультацию")])])])])])], 2)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "status"
    }
  }, [(_vm.form.status !== null) ? _c('form-status', {
    staticClass: "form__status",
    attrs: {
      "status": _vm.form.status,
      "message": _vm.form.message,
      "theme": "inverse"
    },
    on: {
      "close": function($event) {
        _vm.hideStatus()
      }
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-785e6735", module.exports)
  }
}

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);




/**
 * Cool Menu
 * @author      delphinpro <delphinpro@gmail.com>
 * @license     licensed under the MIT license
 */



var CoolMenu = function () {
  function CoolMenu(options) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, CoolMenu);

    var blockClass = 'cool-menu';
    this.data = [];
    this.level = 0;
    this.opt = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
      source: null,
      container: document.body,
      $button: null,
      delimiter: false,
      headerText: 'Menu',
      rootClass: blockClass,
      stateOpenClass: blockClass + '_open',
      scrollPaneClass: blockClass + '__scroll-pane',
      closerClass: blockClass + '__closer',
      headerClass: blockClass + '__header',
      headerInnerClass: blockClass + '__header-in',
      headerActiveClass: blockClass + '__header_active',
      menuClass: blockClass + '__menu',
      menuItemClass: blockClass + '__item',
      menuLinkClass: blockClass + '__link',
      menuNestedClass: blockClass + '__nested',
      backdropClass: blockClass + '-backdrop',
      buttonOpenClass: 'open',
      bodyOpenClass: 'is-open-menu'
    }, options);

    this.headers = [this.opt.headerText];

    this.$coolMenu = __WEBPACK_IMPORTED_MODULE_4_jquery___default()('<div>', { 'class': this.opt.rootClass });
    this.$scrollPane = __WEBPACK_IMPORTED_MODULE_4_jquery___default()('<div>', { 'class': this.opt.scrollPaneClass });
    this.$header = __WEBPACK_IMPORTED_MODULE_4_jquery___default()('<div>', { 'class': this.opt.headerClass });
    this.$headerIn = __WEBPACK_IMPORTED_MODULE_4_jquery___default()('<div>', { 'class': this.opt.headerInnerClass });
    this.$closer = __WEBPACK_IMPORTED_MODULE_4_jquery___default()('<div>', { 'class': this.opt.closerClass });
    this.$backdrop = __WEBPACK_IMPORTED_MODULE_4_jquery___default()('<div>', { 'class': this.opt.backdropClass });

    this.updateHeaderText();
    this.loadData();
    this.attachEvents();
    this.render();
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(CoolMenu, [{
    key: 'updateHeaderText',
    value: function updateHeaderText() {
      this.$headerIn.text(this.headers[this.headers.length - 1]);
    }
  }, {
    key: 'addHeaderText',
    value: function addHeaderText(text) {
      this.headers.push(text);
    }
  }, {
    key: 'removeHeaderText',
    value: function removeHeaderText() {
      this.headers.pop();
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var _this = this;

      this.opt.source.forEach(function (item) {
        var $item = __WEBPACK_IMPORTED_MODULE_4_jquery___default()(item);
        _this.data = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this.data), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this.loadDataFromHtml($item)));
      });
    }
  }, {
    key: 'loadDataFromHtml',
    value: function loadDataFromHtml($menu) {
      var _this2 = this;

      var list = [];
      $menu.children().each(function (index, element) {
        var $li = __WEBPACK_IMPORTED_MODULE_4_jquery___default()(element);
        var $a = $li.find('> a');
        var item = {
          text: __WEBPACK_IMPORTED_MODULE_4_jquery___default.a.trim($a.text()),
          link: $a.attr('href'),
          children: false
        };
        if ($li.find('ul:first').length) {
          item.children = _this2.loadDataFromHtml($li.find('ul:first'));
        }
        list.push(item);
      });
      return list;
    }
  }, {
    key: 'toggleMenu',
    value: function toggleMenu(show) {
      if (this.opt.$button) {
        this.opt.$button.toggleClass(this.opt.buttonOpenClass, show);
      }
      this.$coolMenu.toggleClass(this.opt.stateOpenClass, show);
      __WEBPACK_IMPORTED_MODULE_4_jquery___default()(document.body).toggleClass(this.opt.bodyOpenClass, show);
    }
  }, {
    key: 'attachEvents',
    value: function attachEvents() {
      var _this3 = this;

      this.$coolMenu.on('click.coolMenu', 'a', function (e) {
        var children = __WEBPACK_IMPORTED_MODULE_4_jquery___default()(e.target).data('children');

        if (children) {
          e.preventDefault();
          _this3.level++;

          _this3.renderLevel(children);

          _this3.addHeaderText(__WEBPACK_IMPORTED_MODULE_4_jquery___default()(e.target).text());
          _this3.updateHeaderText();
          _this3.$header.addClass(_this3.opt.headerActiveClass);
          if (_this3.$scrollPane.animate) {
            _this3.$scrollPane.animate({ 'left': '-=100%' });
          } else {
            _this3.$scrollPane.css({ 'left': '-=320px' });
          }
        }
      });

      this.$coolMenu.on('click.coolMenu', '.' + this.opt.headerActiveClass, function (e) {
        e.preventDefault();

        _this3.level--;

        if (_this3.level >= 0) {
          if (_this3.$scrollPane.animate) {
            _this3.$scrollPane.animate({ 'left': '+=100%' }, 300, function () {
              _this3.$coolMenu.find('.' + _this3.opt.menuClass).filter(':last').remove();
              _this3.$header.toggleClass(_this3.opt.headerActiveClass, _this3.level !== 0);
              _this3.removeHeaderText();
              _this3.updateHeaderText();
            });
          } else {
            _this3.$scrollPane.css({ 'left': '+=320px' });
            _this3.$coolMenu.find('.' + _this3.opt.menuClass).filter(':last').remove();
            _this3.$header.toggleClass(_this3.opt.headerActiveClass, _this3.level !== 0);
            _this3.removeHeaderText();
            _this3.updateHeaderText();
          }
        } else {
          _this3.level = 0;
        }
      });

      this.$backdrop.on('click.coolMenu', function (e) {
        _this3.toggleMenu(false);
      });

      this.$closer.on('click.coolMenu', function (e) {
        _this3.toggleMenu(false);
      });

      if (this.opt.$button) {
        this.opt.$button.on('click.coolMenu', function (e) {
          e.preventDefault();
          var stateOpen = _this3.opt.$button.hasClass(_this3.opt.buttonOpenClass);
          _this3.toggleMenu(!stateOpen);
        });
      }
    }
  }, {
    key: 'renderLevel',
    value: function renderLevel(items) {
      var _this4 = this;

      var $level = __WEBPACK_IMPORTED_MODULE_4_jquery___default()('<ul>', { 'class': this.opt.menuClass });

      items.forEach(function (item) {
        var $item = __WEBPACK_IMPORTED_MODULE_4_jquery___default()('<li>', { 'class': _this4.opt.menuItemClass });

        var $a = __WEBPACK_IMPORTED_MODULE_4_jquery___default()('<a>', {
          'class': _this4.opt.menuLinkClass,
          href: item.link,
          text: item.text
        });

        $a.data('children', item.children);
        $a.appendTo($item);

        if (item.children) {
          var $nested = __WEBPACK_IMPORTED_MODULE_4_jquery___default()('<span>', {
            'class': _this4.opt.menuNestedClass,
            // href   : item.link,
            html: '<span>' + item.children.length + '</span>'
          });
          $nested.data('children', item.children);
          $nested.appendTo($item);
        }

        $item.appendTo($level);
      });

      $level.appendTo(this.$scrollPane);
    }
  }, {
    key: 'render',
    value: function render() {
      this.renderLevel(this.data);
      this.$closer.appendTo(this.$header);
      this.$headerIn.appendTo(this.$header);
      this.$header.appendTo(this.$coolMenu);
      this.$scrollPane.appendTo(this.$coolMenu);
      this.$backdrop.appendTo(this.opt.container);
      this.$coolMenu.appendTo(this.opt.container);
    }
  }]);

  return CoolMenu;
}();

/* harmony default export */ __webpack_exports__["a"] = (CoolMenu);

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(110);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(111), __esModule: true };

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(38);
__webpack_require__(112);
module.exports = __webpack_require__(4).Array.from;


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(40);
var $export = __webpack_require__(10);
var toObject = __webpack_require__(33);
var call = __webpack_require__(113);
var isArrayIter = __webpack_require__(114);
var toLength = __webpack_require__(46);
var createProperty = __webpack_require__(115);
var getIterFn = __webpack_require__(116);

$export($export.S + $export.F * !__webpack_require__(118)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(13);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(16);
var ITERATOR = __webpack_require__(0)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(5);
var createDesc = __webpack_require__(15);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(117);
var ITERATOR = __webpack_require__(0)('iterator');
var Iterators = __webpack_require__(16);
module.exports = __webpack_require__(4).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(28);
var TAG = __webpack_require__(0)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(0)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(121);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(122), __esModule: true };

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(123);
var $Object = __webpack_require__(4).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(10);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(7), 'Object', { defineProperty: __webpack_require__(5).f });


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(125),
  /* template */
  __webpack_require__(126),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "D:\\dev\\doSEO\\zel-finance.doseo\\source\\js\\components\\FormStatus.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] FormStatus.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-9b6a6a7c", Component.options)
  } else {
    hotAPI.reload("data-v-9b6a6a7c", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['status', 'title', 'message', 'theme'],
  data: function data() {
    return {
      title0: 'Title',
      message0: 'Message',
      text: {
        success: {
          title: 'Ваша заявка принята',
          message: 'Наш менеджер свяжется с вами в ближайшее время'
        },
        error: {
          title: 'Не удалось отправить заявку',
          message: 'Попробуйте ещё раз'
        }
      }
    };
  },
  mounted: function mounted() {
    if (this.status === true) {
      this.title0 = this.title ? this.title : this.text.success.title;
      this.message0 = this.message ? this.message : this.text.success.message;
    }

    if (this.status === false) {
      this.title0 = this.title ? this.title : this.text.error.title;
      this.message0 = this.message ? this.message : this.text.error.message;
    }
  },

  computed: {
    classes: function classes() {
      var cls = '';
      if (this.status !== null) {
        cls += this.status ? ' form-status_ok' : ' form-status_fail';
      }

      if (this.theme) {
        cls += ' form-status_theme_' + this.theme;
      }

      return cls;
    }
  }
});

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-status",
    class: _vm.classes
  }, [_c('div', {
    staticClass: "container"
  }, [_c('i', {
    staticClass: "form-status__icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "form-status__title"
  }, [_vm._v(_vm._s(_vm.title0))]), _vm._v(" "), _c('div', {
    staticClass: "form-status__message"
  }, [_vm._v(_vm._s(_vm.message0))]), _vm._v(" "), _c('div', {
    staticClass: "form-status__action"
  }, [_c('button', {
    staticClass: "btn",
    class: {
      'btn_inverse': _vm.theme === 'inverse'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_vm._v("\n        Ok\n      ")])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-9b6a6a7c", module.exports)
  }
}

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);

/**
 * zel-finance.doseo
 * 12.09.2017 14:31
 * @author      delphinpro <delphinpro@gmail.com>
 * @copyright   copyright © 2017 delphinpro
 * @license     licensed under the MIT license
 */



/* harmony default export */ __webpack_exports__["a"] = (function (options) {
  options = options || {};
  if (options.toString() !== '[object Object]') {
    options = {};
  }

  options = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    button: 'hamburger',
    stateOpenClass: 'hamburger_state_cross',
    stateOpenFlag: 'f-hamburger-open'
  }, options);

  var $hamburger = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.' + options.button);

  $hamburger.on('click', function () {
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()(document.documentElement).toggleClass(options.stateOpenFlag);
    $hamburger.toggleClass(options.stateOpenClass);
  });
});

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fixedbar;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

function fixedbar(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var o = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    scrollToggle: window.innerHeight * 0.75,
    transitionDuration: 300
  }, options);

  var stateFixed = false;
  var pane = el.querySelector('.fixed-bar__pane');

  window.addEventListener('scroll', function (e) {
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop > o.scrollToggle) {
      if (!stateFixed) {
        stateFixed = !stateFixed;
        el.style.paddingTop = pane.clientHeight + 'px';
        el.classList.add('is-fixed');
        pane.style.top = -pane.clientHeight + 'px';
        setTimeout(function () {
          pane.classList.add('in');
          setTimeout(function () {
            return pane.style.top = 0;
          }, 0);
        }, 0);
      }
    } else {
      if (stateFixed) {
        stateFixed = !stateFixed;
        pane.style.top = -pane.clientHeight + 'px';
        setTimeout(function () {
          pane.classList.remove('in');
          el.classList.remove('is-fixed');
          pane.style.top = '';
          el.style.paddingTop = '';
        }, o.transitionDuration);
      }
    }
  });
}

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(130),
  /* template */
  __webpack_require__(131),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "D:\\dev\\doSEO\\zel-finance.doseo\\source\\js\\components\\Modal.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Modal.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7724861e", Component.options)
  } else {
    hotAPI.reload("data-v-7724861e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal"
  }, [_c('div', {
    staticClass: "modal__mask",
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal__dialog"
  }, [_c('button', {
    staticClass: "modal__close close",
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticClass: "modal__header"
  }, [_vm._t("header")], 2), _vm._v(" "), _c('div', {
    staticClass: "modal__body"
  }, [_vm._t("body")], 2), _vm._v(" "), _c('div', {
    staticClass: "modal__footer"
  }, [_vm._t("footer")], 2)])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7724861e", module.exports)
  }
}

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(133),
  /* template */
  __webpack_require__(134),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "D:\\dev\\doSEO\\zel-finance.doseo\\source\\js\\components\\News\\News.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] News.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-30fc8bf3", Component.options)
  } else {
    hotAPI.reload("data-v-30fc8bf3", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sendAjax__ = __webpack_require__(37);



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    api: String,
    action: String,
    entriesPerPage: [Number, String],
    category: String,
    categoryTotal: [Number, String],
    initialContainer: String
  },

  data: function data() {
    return {
      newsList: [],
      tabList: [],
      moreExists: true,
      isLoading: false,
      nextId: 0,
      perPage: null,
      selectedCategory: '',
      total: 0,
      hasErrors: false,
      statusMsg: ''
    };
  },
  created: function created() {
    console.log('News Component: Created');
    this.selectedCategory = this.category;
    this.total = this.normalizeInteger(this.categoryTotal, 1);
    this.perPage = this.normalizeInteger(this.entriesPerPage, 9);

    if (!this.action) {
      throw new Error('News Component: Invalid param «action», should be not empty');
    }
  },
  mounted: function mounted() {
    if (!this.parseInitialData()) {
      this.addNews();
    }
  },


  methods: {
    normalizeInteger: function normalizeInteger(input, defaultValue) {
      var i = parseInt(input);
      return isNaN(i) || i < 0 ? defaultValue : i;
    },
    parseInitialData: function parseInitialData() {
      var rootNode = document.getElementById(this.initialContainer || 'news');
      if (rootNode) {
        this.parseTabsData(rootNode);
        this.parseNewsData(rootNode);
        this.updateStateVisibleMoreButton();
        rootNode.innerHTML = '';
      }
      return !!rootNode;
    },
    parseTabsData: function parseTabsData(rootNode) {
      var _this = this;

      rootNode.querySelectorAll('.tab').forEach(function (item, index) {
        var isActive = item.classList.contains('is-active');
        var total = parseInt(item.dataset.total);
        var year = item.dataset['year'];
        var title = item.querySelector('.tab__title').innerText;

        _this.tabList.push({ id: index, title: title, year: year, total: total, isActive: isActive });

        if (isActive) {
          _this.total = total;
          _this.selectedCategory = year;
        }
      });
      // console.log('TabsList: ', this.tabList);
    },
    parseNewsData: function parseNewsData(rootNode) {
      var _this2 = this;

      rootNode.querySelectorAll('.news-tile').forEach(function (item, index) {
        var dateNode = item.querySelector('.news__date');
        var linkNode = item.querySelector('.news__link');
        _this2.newsList.push({
          id: index,
          date: dateNode.getAttribute('datetime'),
          formattedDate: dateNode.innerText,
          link: linkNode.getAttribute('href'),
          title: linkNode.innerText,
          text: item.querySelector('.news__content').innerHTML
        });
      });
      this.nextId = this.newsList.length;
      // console.log('NewsList: ', this.newsList);
    },
    loadNews: function loadNews(year, start, count) {
      var _this3 = this;

      this.resetErrors();
      this.isLoading = true;

      var fd = new FormData();
      fd.append('action', this.action);
      fd.append('year', year);
      fd.append('start', start);
      fd.append('count', count);

      return Object(__WEBPACK_IMPORTED_MODULE_1__sendAjax__["a" /* default */])(this.api, {
        body: fd
      }).then(function (response) {
        console.log('Ajax response:', response);
        _this3.isLoading = false;
        return response;
      }).catch(function (error) {
        console.error(error);
        _this3.isLoading = false;
        _this3.statusMsg = error.message;
        _this3.hasErrors = true;
      });
    },
    addNews: function addNews() {
      var _this4 = this;

      this.loadNews(this.selectedCategory, this.nextId, this.perPage).then(function (response) {
        response['payload'].forEach(function (item) {
          _this4.newsList.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            id: _this4.nextId++
          }, item));
        });

        _this4.updateStateVisibleMoreButton();
      });
    },
    setActiveTab: function setActiveTab(id) {
      var _this5 = this;

      if (this.isLoading || this.tabList[id]['isActive']) return;

      var tabs = [];

      this.tabList.forEach(function (item, index) {
        item.isActive = index === id;
        tabs.push(item);

        if (item.isActive) {
          _this5.total = item.total;
          _this5.selectedCategory = item.year;
        }
      });

      this.loadNews(this.selectedCategory, 0, this.perPage).then(function (response) {
        _this5.tabList = tabs;
        _this5.newsList.splice(0);

        setTimeout(function () {
          _this5.nextId = 0;
          response['payload'].forEach(function (item) {
            _this5.newsList.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
              id: _this5.nextId++
            }, item));
          });

          _this5.updateStateVisibleMoreButton();
        }, 0);
      });
    },
    updateStateVisibleMoreButton: function updateStateVisibleMoreButton() {
      this.moreExists = this.newsList.length < this.total;
    },
    resetErrors: function resetErrors() {
      this.statusMsg = '';
      this.hasErrors = false;
    }
  }
});

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'news-component_is-loading': _vm.isLoading
    }
  }, [_c('div', {
    staticClass: "tabs tabs_center",
    attrs: {
      "role": "tablist"
    }
  }, _vm._l((this.tabList), function(item) {
    return _c('a', {
      key: item.id,
      staticClass: "tab tabs__item",
      class: {
        'is-active': item.isActive,
          'is-loading': item.isActive && _vm.isLoading,
          'is-disabled': _vm.isLoading
      },
      attrs: {
        "role": "tab",
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setActiveTab(item.id)
        }
      }
    }, [_c('div', {
      staticClass: "tab__title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "badge tab__badge"
    }, [_vm._v(_vm._s(item.total))])])
  })), _vm._v(" "), _c('div', {
    staticClass: "news-tiles mt-2.25"
  }, [_c('div', {
    staticClass: "news-tiles__container"
  }, [(!_vm.hasErrors) ? _c('transition-group', {
    attrs: {
      "name": "list"
    }
  }, _vm._l((this.newsList), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "news-tiles__tile"
    }, [_c('div', {
      staticClass: "news-tile"
    }, [_c('article', {
      staticClass: "news"
    }, [_c('time', {
      staticClass: "news__date",
      attrs: {
        "datetime": item.date
      }
    }, [_vm._v(_vm._s(item.formattedDate))]), _vm._v(" "), _c('h2', {
      staticClass: "news__title"
    }, [_c('a', {
      staticClass: "news__link",
      attrs: {
        "href": item.link
      }
    }, [_vm._v(_vm._s(item.title))])]), _vm._v(" "), _c('div', {
      staticClass: "news__content"
    }, [_vm._v(_vm._s(item.text))])])])])
  })) : _vm._e(), _vm._v(" "), (_vm.hasErrors) ? _c('div', {
    staticClass: "alert alert_danger"
  }, [_vm._v(_vm._s(_vm.statusMsg))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "news-tiles__footer"
  }, [(_vm.moreExists && !_vm.hasErrors) ? _c('button', {
    staticClass: "btn btn_outline",
    class: {
      'is-loading': _vm.isLoading
    },
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.addNews
    }
  }, [_vm._v("Показать еще\n      ")]) : _vm._e()])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-30fc8bf3", module.exports)
  }
}

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(136),
  /* template */
  __webpack_require__(137),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "D:\\dev\\doSEO\\zel-finance.doseo\\source\\js\\components\\Radio.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Radio.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-09447f3f", Component.options)
  } else {
    hotAPI.reload("data-v-09447f3f", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(17);



/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  props: ['value', 'name', 'checked', 'disabled'],
  model: {
    prop: 'checked',
    event: 'change'
  },
  methods: {
    onChange: function onChange() {
      this.$emit('change', this.value);
    }
  }
}));

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    attrs: {
      "type": "radio",
      "disabled": _vm.disabled,
      "name": _vm.name
    },
    domProps: {
      "checked": _vm.checked == _vm.value,
      "value": _vm.value
    },
    on: {
      "change": _vm.onChange
    }
  }), _vm._v(" "), _c('i'), _c('span', [_vm._t("default")], 2)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-09447f3f", module.exports)
  }
}

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/**
 * zel-finance.doseo
 * @since       26.09.2017 19:38
 * @author      delphinpro <delphinpro@gmail.com>
 * @copyright   copyright © 2017 delphinpro
 * @license     licensed under the MIT license
 */



/* harmony default export */ __webpack_exports__["a"] = (function (selector) {
  var $topper = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(selector);
  var $window = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window);

  if ($topper.hasClass('is-init')) return;

  $window.on('scroll', function (e) {
    if ($window.scrollTop() > $window.height()) {
      $topper.addClass('is-active');
    } else {
      $topper.removeClass('is-active');
    }
  });

  $topper.on('click', function (e) {
    e.preventDefault();

    var timeOut = void 0;

    function goUp() {
      var top = Math.max(document.body.scrollTop, document.documentElement.scrollTop);
      if (top > 0) {
        window.scrollBy(0, -100);
        timeOut = setTimeout(goUp, 10);
      } else {
        clearTimeout(timeOut);
      }
    }

    goUp();
  });

  $topper.addClass('is-init');
});

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Detect supported transition event
 * https://jonsuh.com/blog/detect-the-end-of-css-animations-and-transitions-with-javascript/
 * @returns {String}
 */
function whichTransitionEvent() {
  var t = void 0,
      el = document.createElement('fake');

  var transitions = {
    'transition': 'transitionend',
    'OTransition': 'oTransitionEnd',
    'MozTransition': 'transitionend',
    'WebkitTransition': 'webkitTransitionEnd'
  };

  for (t in transitions) {
    if (el.style[t] !== undefined) {
      return transitions[t];
    }
  }
}

var transitionEvent = whichTransitionEvent();

/* harmony default export */ __webpack_exports__["a"] = (transitionEvent);

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(141),
  /* template */
  __webpack_require__(142),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "D:\\dev\\doSEO\\zel-finance.doseo\\source\\js\\components\\YandexMap.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] YandexMap.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-08d4ae22", Component.options)
  } else {
    hotAPI.reload("data-v-08d4ae22", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
//
//
//
//
//
//
//
//
//
//
//



var EVENT_YANDEX_MAP_READY_NAME = 'yandexMapReady';

var apiScriptTag = null;
var yandexMapApiReady = false;

function ymApiReady(onReady) {
  var el = void 0;
  var firstScriptTag = void 0;

  if (!apiScriptTag) {
    console.log('Yandex maps API initialize...');

    apiScriptTag = true;

    el = document.createElement('script');
    el.setAttribute('charset', 'utf-8');
    el.setAttribute('async', 'async');
    el.setAttribute('src', '//api-maps.yandex.ru/2.1/?lang=ru_RU');

    el.onload = function () {
      console.log('Yandex maps API is ready.');
      yandexMapApiReady = true;
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).trigger(EVENT_YANDEX_MAP_READY_NAME);
    };

    firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(el, firstScriptTag);
  }

  if (typeof onReady === 'function') {
    if (yandexMapApiReady) {
      onReady();
    } else {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).one(EVENT_YANDEX_MAP_READY_NAME, function () {
        onReady();
      });
    }
  }
}

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['id', 'center', 'zoom'],

  mounted: function mounted() {
    var _this = this;

    console.log('YM mounted');
    var center = this.center || [55.75161665120035, 37.61788699999992];
    var zoom = this.zoom || 15;

    ymApiReady(function () {
      ymaps.ready(function () {
        console.log(_this.id);

        var myMap = new ymaps.Map(_this.id, {
          center: center,
          zoom: zoom
        });

        myMap.behaviors.disable(['scrollZoom']);

        var myPlacemark = new ymaps.Placemark(myMap.getCenter(), {}, {
          iconLayout: 'default#image',
          iconImageHref: '/design/images/point.png',
          iconImageSize: [67, 89],
          iconImageOffset: [-33, -89]
        });

        myMap.geoObjects.add(myPlacemark);
      });
    });
  },
  data: function data() {
    return {};
  }
});

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "map"
  }, [_c('div', {
    staticClass: "map__photo"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "map__map"
  }, [_c('div', {
    staticClass: "map__container",
    attrs: {
      "id": _vm.id
    }
  })])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-08d4ae22", module.exports)
  }
}

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// main.bundle.js